import { MAXIMUM_MESSAGE_SIZE, MESSAGE_SIZE_DISPLAY } from "../global.constants";

export const successMessages = {
  CREATION_SUCCESSFUL: "Successfully created",
  UPDATED_SUCCESSFULLY: "Successfully Updated",
  REMOVED_SUCCESSFULLY: "Successfully Removed",
  SUBMITTED_SUCCESSFULLY: "Submitted Successfully",
  EMAIL_SUCCESSFULLY_SENT: "Email sent successfully!",
  USER_CREATION_FOR_FRANCHISE:
    "Please create a user for the Group you have just created",
  USER_CREATION_AND_VERIFICATION: `User has been successfully created. Please check the provided email to verify account`,
  RESET_PASSWORD_SUCCESS: "Password Changed Successfully",
  VERIFIED_SUCCESSFULLY: "Verified Successfully",
  REINVITE_SUCCESSFULLY: "Invitation Resend Successfully",
  REACTIVATE_ARCHIVED_QUESTION_SUCCESSFULLY:
    "Question reactivated successfully",
  SUCCESSFULLY_RESOLVED: "Successfully Resolved!",
  INTERNAL_NOTES_SAVED: "Internal Notes Saved Successfully!",
  CONNECTION_SUCCESSFUL: "Connection Successfull",
  CONNECTION_FAILED: "Connection Failed",
  RESEND_SUCCESSFULLY: "Resend it Successfully",
  RESEND_FAILED: "Failed to Send",
  EXPORT_DETAIL_CUSTOMER_SURVEY_DATA_SUCCESS_MESSAGE:
    "Thank you for your patience as we finalize the survey data. We will email you the attached report as soon as it is ready.",
  DUBLICATE_STORE_MERGING_START_MESSAGE:
    "Stores Merge Process Started. For Status Check Logs",
};
export const errorMessages = {
  BRAND_REPORT_FETCH_FAILED: "Failed to fetch brand report. Please try again.",
  SELECT_ONE_PLEASE: "Select one please",
  SEQUENCE_WITH_NO_ELEMENT: "Sequence contains no elements.",
  SURVEY_DOES_NOT_EXIST: "Survey does not exist.",
  REQUIRED_FIELDS_MISSING: "Required fields are missing!",
  SURVEY_CREATION_VALIDATION_ERROR:
    "Please fill all question fields and save survey!",
  PLEASE_FILL_MESSAGE_FIELD: "Please fill message field",
  EMAIL_SENDING_FAILED: "Failed to send email. Please try again!",
  PASSWORD_NOT_MATCHED_ERROR: "Password and Confirm Password doesn't matched!",
  PLEASE_SELECT_FRANCHISE: "Please select group!",
  PLEASE_ADD_INTERNAL_NOTES: "Please add Internal Notes first!",
  IMAGE_SIZE_EXCEED: "Image size must be less or equal to 5MB!",
  SELECT_BRAND: "Please select the Brand Name",
  INVALID_FILE_TYPE:
    "Invalid file type. Only .svg, .jpg, .jpeg, .jfif and .png are allowed.",
  MESSAGE_SIZE_EXCEED: `Message size exceeds the limit of ${MAXIMUM_MESSAGE_SIZE}${MESSAGE_SIZE_DISPLAY.MEGABYTE_UNIT_LABEL}!`,
  MESSAGE_SENDING_FAILED:
    "Message sending failed, please reload the page if the issue persist!",
  BRAND_GROUP_ACCESS_DENIED:
    "You do not have permission to receive live inbox updates for this brand.",
  BRAND_GROUP_JOIN_FAILED:
    "Unable to connect to live inbox updates. Please reload the page to try again.",
  SIGNALR_SEND_DATA_FAILED: "Error sending data to server",
  SIGNALR_START_LISTENERS_FAILED:
    "Error while starting server when Listening to Listeners:",
  SIGNALR_REMOVE_LISTENERS_FAILED:
    "Error while starting server when removing Listeners:",
  SIGNALR_START_MESSAGE_SEND_FAILED:
    "Error while starting server when sending message:",
  SIGNALR_INVOKE_FAILED: "Error while envoking",
  SIGNALR_START_INVOKE_FAILED:
    "Error while starting connection when envoking",
  NO_DATA_FOUND_IN_SELECTED_DATE_RANGE:
    "No data available for the selected date range.",
  UNABLE_TO_GENERATE_RESPONSE: "Unable to generate Response, Please try again",
  AI_REQUEST_IN_PROGRESS:
    "This conversation is already processing a request. Please wait a moment and try again.",
  AI_REQUEST_IN_PROGRESS_RELOAD_THE_PAGE_OR_REOPEN_THE_POPUP:
    "This conversation is processing a request. Please reload the page or reopen the pop-up.",
  FAILED_TO_FETCH_BRANDS_FOR_AI_REPLY:
    "Failed to fetch brands for AI Reply. Please try again later!",

  FAILED_TO_UPDATE_BRAND_SOCIAL_LINKS:
    "Failed to update brand social links. Please try again!",
  FAILED_TO_UPDATE: "Failed to update.",

  FAILED_TO_FETCH_BRAND_SOCIAL_LINKS: "Failed to fetch brand social links.",
};

export const infoMessages = {
  USER_PROFILE_UPDATED:
    "Your profile has been updated and you are being logged out. Please log in again to continue.",
  USER_PROFILE_DELETED:
    "Your account has been deleted and you are being logged out. Please contact support team.",
  SELECT_PREVIOUS_DATE: "The date must be in the past.",
};

export const errorMessage = { message: "Something went wrong" };

export const toastTypes = {
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  DEFAULT: "default",
};

export const verifyMessages = {
  APPLIED_TO_ALL:
    "Do you want to enable this feature across all stores under this brand?",
};
